import { DateTime } from "luxon"

export function roundToNearest5Minutes(dateTime: DateTime): DateTime {
    const minutes = Math.round(dateTime.minute / 5) * 5
    return dateTime.set({ second: 0, millisecond: 0 }).set({
        minute: minutes % 60,
        hour: dateTime.hour + Math.floor(minutes / 60),
    })
}
